import React, {useState, FunctionComponent, useEffect} from "react"
import Button from "@murphy-frontend/web-core/components/Button"
import {FilterType} from "@murphy-frontend/web-core/components/FilterControl"
import FilterToggle from "@murphy-frontend/web-core/components/FilterToggle"
import Checkbox from "@murphy-frontend/web-core/components/Checkbox"

interface FilterModalProps {
	allFilters: FilterType[]
	closeModal: () => void
	toggleFilter: (filter: FilterType[]) => void
	reset: () => void
	translations: Record<any, any>
}

const FiltersParent: FunctionComponent<FilterModalProps> = ({
	allFilters,
	closeModal,
	toggleFilter,
	reset,
	translations
}) => {
	const [filters, setFilters] = useState<FilterType[]>(allFilters)
	const [checked, setChecked] = useState(false)

	const checkboxRows = filters.find(filter => filter.columnname === "nonzero")

	useEffect(() => {
		setFilters(allFilters)
	}, [allFilters])

	useEffect(() => {
		if (checkboxRows) setChecked(checkboxRows.isActive)
	}, [checkboxRows])

	const handleSubmit = () => {
		toggleFilter(filters)
		closeModal()
	}

	const handleFilter = (filter: FilterType) => {
		const updatedFilter = {...filter, isActive: !filter.isActive}
		let updatedFilters = [...filters]
		const idx = updatedFilters.findIndex(row => row.displayName === filter.displayName)
		updatedFilters[idx] = updatedFilter
		setFilters(updatedFilters)
	}

	const handleClear = () => {
		reset()
		closeModal()
	}

	const filterSection = (filtersRow: FilterType[], title: string) => {
		return (
			<section className='flex-container-full-width row'>
				<div className='filters-header'>{title}</div>
				<div className='filters-row'>
					{filtersRow.map(filter => (
						<FilterToggle
							filterName={filter.displayName}
							key={filter.displayName}
							checked={filter.isActive}
							handleClick={() => handleFilter(filter)}
						/>
					))}
				</div>
			</section>
		)
	}

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setChecked(e.target.checked)
		handleFilter(checkboxRows)
	}

	return (
		<div>
			{checkboxRows && (
				<Checkbox
					name={checkboxRows.columnname}
					title={checkboxRows.displayName}
					checked={checked}
					handleChange={handleChange}
				/>
			)}
			<section className='flex-container-full-width row filter-button-container'>
				<Button onClick={handleSubmit}>{translations.save}</Button>
				<Button buttonStyle={"btn--outline"} isClearButton={true} onClick={handleClear}>
					{translations.clearall}
				</Button>
			</section>
		</div>
	)
}

export default FiltersParent
